import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from '../../images/LOGO.png';
import { masterLoginUser } from "../../Actions/AuthAction";
import TitleBar from "../TitleBar";
import LoginFooter from "./LoginFooter";
import { appName } from "../../Global/Global";


const MasterLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loader, setLoader] = useState(false);
    const [user, setUser] = useState({
        email: '',
        password: '',
        useremail: ""
    })

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    const onFormSubmit = (e) => {
        e.preventDefault();
        setLoader(true);
        dispatch(masterLoginUser(user, setLoader, navigate));
    }

    return (
        <>
            <TitleBar title="Master Login" />

            <header className="loginHeader">
                <div className="container">
                    <div className="loginLogo">
                        {/* <img src={logo} alt=""/> */}
                        <h1 style={{ color: "white" }}>{appName}</h1>
                    </div>
                </div>
            </header>

            <div className="login-container">
                <div className="container full-height-container">
                    <div className="row full-height-row align-items-center">
                        <div className="col-lg-6">
                            <div className="login-container-left">
                                <h2>Welcome <span>Back!</span></h2>
                                <p>Create Video Courses, VSL and more easily using <br /> moderner drag-n-drop based timeline editor</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="login-container-right">
                                <div className="login-container-right-main">
                                    <h2 className="mb-3"><span>Login</span> to Your Account Now</h2>
                                    <form method="post" onSubmit={(e) => onFormSubmit(e)}>
                                        <div className="form-group">
                                            <label>User Email Address</label>
                                            <input type="email" name="useremail" className="form-control"
                                                placeholder="User Email" required
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                        <div className="form-group my-1">
                                            <label>Admin Email Address</label>
                                            <input type="email" name="email" className="form-control"
                                                placeholder="Admin Email" required
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                        <div className="form-group my-1">
                                            <label>Admin Password</label>
                                            <input type="password" name="password" className="form-control"
                                                placeholder="************" required
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-block btn-primary themeBtn" disabled={loader}>
                                                {loader ? <i className="fa fa-spinner fa-spin mr-2" /> : ''} Login to {appName}
                                            </button>
                                        </div>

                                        <div className="form-group">
                                            <p className="forgotLink">Forgot your account details? <Link to="/forget-password" className="text-center "> Click here</Link></p>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <LoginFooter />

        </>
    )
}

export default MasterLogin;